class SilentConsole {
  log () {}
  error () {}
  warn () {}
}

if(typeof window !== 'undefined' && typeof window.console === 'undefined') {
  window.console = new SilentConsole();
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/utils/console.js